'use client';

import { MouseEvent } from 'react';
import { useTranslation } from '../lib/i18n';
import type { TocHeading } from './PageRenderer';

/**
 * Obsah dlouhého článku nápovědy — klikací seznam H2/H3 nadpisů.
 * Scrollování používá scrollIntoView, takže funguje jak na celé stránce,
 * tak uvnitř posuvného postranního panelu.
 */
export default function HelpToc({ headings, onNavigate, hideLabel }: { headings: TocHeading[]; onNavigate?: () => void; hideLabel?: boolean }) {
  const { t } = useTranslation();
  if (headings.length < 3) return null;

  const go = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', `#${id}`);
    onNavigate?.();
  };

  return (
    <nav aria-label={t('napovedaToc')}>
      {!hideLabel && <div className="text-xs font-semibold text-wood/70 uppercase tracking-wide mb-2">{t('napovedaToc')}</div>}
      <ul className="space-y-1">
        {headings.map((h, i) => (
          <li key={`${h.id}-${i}`}>
            <a
              href={`#${h.id}`}
              onClick={(e) => go(e, h.id)}
              className={`block text-sm text-wood hover:text-moss-dark transition leading-snug ${h.level === 3 ? 'pl-4 text-wood/80' : ''}`}
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
